import { FC } from 'react';

import { DoneIconWrapStyled, SuccessMessageStyled } from './SuccessSection.styled';
import { DoneIcon } from 'icons';

export type SuccessSectionPropsT = {
  message: string;
};

const SuccessSection: FC<SuccessSectionPropsT> = ({ message }) => (
  <>
    <DoneIconWrapStyled>
      <DoneIcon size="13xl" color="brightGreen" />
    </DoneIconWrapStyled>
    <SuccessMessageStyled align="center" variant="h3" color="darkBlue">
      {message}
    </SuccessMessageStyled>
  </>
);

export default SuccessSection;
